<template>
  <div class="bill-export-container">
    <div v-if="loading" class="mask">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="percentage" text-color="white"/>
        <h2 style="color: #FFFFFF;text-align: center;">下载中...</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          下载数 {{ total }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s</h3>
      </div>
    </div>
  </div>
</template>
<script>
import {export_json_to_excel} from '@/utils/export/excel'
import {getChars, parseTime} from '@/utils'
import {getBillList} from "@/api/bill";

let export_need_orders = false
const statusMap = {
  wait: "待审核",
  pass: "已通过",
  reject: "已拒绝",
};

/**
 * 导出头部
 */
const fieldMap = {
  '序号': 'index',
  '申请人': 'applicant',
  '乙方': 'company_name',
  '客户名称': 'customer_name',
  '发票抬头': 'invoice_title',
  '发票金额': 'amount_money',
  '发票类型': '_type',
  '税号': 'tax_id',
  '发票内容': 'content',
  '收件人邮箱': 'contact_email',
  '发票号码': 'invoice_number',
  '审核状态': '_status',
  '申请时间': 'created_at',
  '审核时间': 'check_time',
  '审核金额': 'check_money',
  '发票备注栏': 'remark',
  '财务备注': 'remark_financial',
}
export default {
  name: 'BillExport',
  props: {
    search: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      interval: null,
      interval_ms: 0,
      total: 0,
      percentage: 0
    }
  },
  methods: {
    statusFilter(status) {
      const statusMap = {
        'spe_invoice': '电子专票',
        'common_invoice': '电子普票',
      }
      return statusMap[status] || ''
    },
    handelDo: async function (cmd) {
      const _this = this
      _this.interval_ms = 0
      _this.interval_ms && clearInterval(_this.interval_ms)
      const callback = () => {
        _this.$message.success('导出成功')
        _this.interval_ms && clearInterval(_this.interval_ms)
      }
      _this.interval = setInterval(function () {
        _this.interval_ms += 10
      }, 10)

      _this.percentage = 0
      this.loading = true
      const json = await this.getData(cmd)
      this.loading = false
      const {array: tableData, merges} = this.filterJson(json)

      export_json_to_excel(
          {
            fieldMap,
            sourceData: tableData,
            filename: '导出数据',
            mergeColumns: merges
          }, callback
      )
    },
    getData: async function (cmd) {
      const _this = this
      let array = []
      const params = {...{}, ...this.search}
      params.page = 1
      params.per_page = 500
      params.need_orders = export_need_orders
      if (cmd === 'all') {
        params.status = null;
      }
      const {model: {total}} = await getBillList(params)
      this.total = total
      for (let i = 0; i < total; i += params.per_page) {
        const {model: {data}} = await getBillList(params)
        array = [...array, ...data]
        params.page++
        _this.percentage = parseInt((i / total * 100) + '')
      }
      return array
    },
    handelStart: function (cmd) {
      this.$confirm('选择导出是否带有订单明细的表格', '提示', {
        confirmButtonText: '无订单明细',
        cancelButtonText: '有订单明细',
        type: 'warning',
        distinguishCancelAndClose: true,
      }).then(async () => {
        export_need_orders = false
        if (fieldMap['订单明细'] !== undefined) {
          delete fieldMap['订单明细'];
        }
        await this.handelDo(cmd)
      }).catch((action) => {
        if (action === 'cancel') {
          export_need_orders = true
          fieldMap['订单明细'] = {
            '订单编号': 'order_no',
            '含税收入': 'payment_account',
            '申请金额': 'invoice_money',
            '客户名称': 'customer_name',
            '执行时间': 'exec_timestamp',
            '执行价': 'exec_price',
          }
          this.handelDo(cmd)
        }
      });
    },
    filterJson(json) {
      const fields = ['order_no', 'payment_account', 'invoice_money', 'customer_name', 'exec_timestamp', 'exec_price']

      let merge_index = 3
      let merge_end_index = 0
      const array = []
      const merges = []
      const chars = getChars('X')
      json.forEach((row, index) => {
        const obj = {...{}, ...row}
        obj.index = (index + 1)
        obj.company_name = row.company ? row.company.name : null
        obj._address = `${row.province || ''}${row.city || ''}${row.area || ''}${row.address || ''}`
        obj._contact_address = `${row.contact_province || ''}${row.contact_city || ''}${row.contact_area || ''}${row.contact_address || ''}`
        obj._status = statusMap[row.status] || ''
        obj._type = this.statusFilter(row.type)
        obj.created_at = row.created_at || null
        obj.updated_at = row.updated_at || null
        obj.check_time = obj.check_time ? parseTime(obj.check_time, '{y}-{m}-{d}') : null

        if (fieldMap['订单明细'] !== undefined) {
          const children = row.order_rel
          if (Array.isArray(children)) {
            children.map((child) => {
              const obj_child = {...{}, ...obj}
              fields.map(field => {
                let child_field_value = child[field] || null
                if (field === 'exec_timestamp') {
                  child_field_value = child_field_value ? parseTime(child_field_value, '{y}-{m}-{d}') : null
                }
                obj_child[field] = child_field_value
              })
              array.push(obj_child)

              // 合并逻辑
              const merge_start_index = merge_index
              if (merge_start_index > merge_end_index) {
                merge_end_index = merge_index + (children.length) - 1
                chars.map(c => {
                  merges.push(`${c}${merge_start_index}:${c}${merge_end_index}`)
                })
              }
              merge_index++
            })
          }
        } else {
          array.push(obj)
        }
      })
      return {array, merges}
    }
  }
}

</script>
<style lang="scss">
.bill-export-container {
  .el-button [class*=el-icon-] + span {
    margin-left: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
